import { createElement } from 'react';

const DynamicIcon = ({ iconName, className, weight, size, onClick, color }) => {
    try {
        // eslint-disable-next-line global-require
        const requiredIcon = require(`phosphor-react/dist/icons/${iconName || 'Star'}.esm.js`).default;
        return createElement(requiredIcon, { className, weight, size, onClick, color });
    } catch {
        // eslint-disable-next-line global-require
        const defaultIcon = require('phosphor-react/dist/icons/Star.esm.js').default;
        return createElement(defaultIcon, { className, weight, size, onClick, color });
    }
};

export default DynamicIcon;
